/**
 * @format
 * @module lib/audience/secrets
 */
import { getProp } from "utils/utils";
import { API_TIMEOUT, API_PUBLIC_ENCRYPT, API_PUBLIC_DECRYPT } from "lib/gamservices";
import { validStatus, handleJSON, fetchTimeout } from "utils/fetch";

/**
 * Encrypt a plain-text string value, that can be decrypted later.
 * @param {String} [encode=""] - value to encode
 * @returns {Promise<String>}
 */
export function encrypt(encode = "") {
  const config = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify([{ data: encode }])
  };

  return fetchTimeout(API_TIMEOUT, fetch(API_PUBLIC_ENCRYPT, config))
    .then(validStatus)
    .then(handleJSON)
    .then(handleEncrypt);
}

/**
 * Decrypt a previously encrypted string value.
 * @param {String} [decode=""] - value to decode
 * @returns {Promise<String>}
 */
export function decrypt(decode = "") {
  const config = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify([{ dataEnc: decode }])
  };

  return fetchTimeout(API_TIMEOUT, fetch(API_PUBLIC_DECRYPT, config))
    .then(validStatus)
    .then(handleJSON)
    .then(handleDecrypt);
}

/**
 * Handle the decrypt API response
 * @param {Object} res - with success or error
 * @returns {String} of decoded value
 */
function handleDecrypt(res) {
  const error = getProp(res, "error");
  if (error != null) {
    throw new Error(error);
  }
  const value = getProp(res, "[0].data");
  if (value == null) {
    throw new Error("Decrypted value not returned");
  }
  return value;
}

/**
 * Handle the encrypt API response
 * @param {Object} res - with success or error
 * @returns {String} of encoded value
 */
function handleEncrypt(res) {
  const error = getProp(res, "error");
  if (error != null) {
    throw new Error(error);
  }
  const value = getProp(res, "[0].dataEnc");
  if (value == null) {
    throw new Error("Encrypted value not returned");
  }
  return value;
}
